"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const Chip = (props) => {
    const { color, label, variant, size = "small", iconColor, onClick, onDelete, sx = {} } = props;
    return (react_1.default.createElement(material_1.Chip, { icon: color ? (react_1.default.createElement(iconoir_react_1.Circle, { width: "0.7rem", height: "0.7rem", fill: iconColor, style: { paddingLeft: "0.3rem", color: iconColor } })) : null, deleteIcon: onDelete ? react_1.default.createElement(iconoir_react_1.Cancel, { width: "1.2rem", height: "1.2rem", style: { color: colors_1.default.icons[700] } }) : null, label: label, variant: variant, size: size, sx: { backgroundColor: color, color: colors_1.default.text[100], ...sx }, onDelete: onDelete, onClick: onClick }));
};
exports.default = Chip;
